const awsmobile = {
	"aws_project_region": "eu-west-1", 
	"aws_cognito_region": "eu-west-1", 
	"aws_appsync_graphqlEndpoint": "https://bp2mmeedw5fw7k4sfuot6wxqu4.appsync-api.eu-west-1.amazonaws.com/graphql", 
	"aws_appsync_region": "eu-west-1", 
	"aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS", 
	"endpointGetTenant": "https://fve1w97wyj.execute-api.eu-west-1.amazonaws.com/ApiGetTenantConfig"
}; 

export default awsmobile;